export function useAPIUsagesInit() {
  const drm_pf_api_summary_th = [
    {
      label: '課金\n区分',
      width: '2rem',
      rowspan: 2,
      colspan: 1,
      bold: false
    },
    {
      label: '基本料金',
      width: '4rem',
      rowspan: 2,
      colspan: 1,
      bold: false
    },
    {
      label: 'データ取得件数',
      width: '7rem',
      rowspan: 1,
      colspan: 1,
      bold: false
    },
    {
      label: 'データ取得料',
      width: '18rem',
      rowspan: 1,
      colspan: 4,
      bold: false
    },
    {
      label: '割引',
      width: '7rem',
      rowspan: 1,
      colspan: 2,
      bold: false
    },
    {
      label: 'データ取得料\n（割引適用後）',
      width: '6rem',
      rowspan: 2,
      colspan: 1,
      bold: false
    },
    {
      label: '請求額（税抜）',
      width: '8rem',
      rowspan: 2,
      colspan: 1,
      bold: true
    },
    {
      label: '消費税率',
      width: '5rem',
      rowspan: 2,
      colspan: 1,
      bold: true
    },
    {
      label: '請求額（税込）\n※暫定',
      width: '8rem',
      rowspan: 2,
      colspan: 1,
      bold: true
    },
  ]
  const drm_pf_api_summary_th_2nd = [
    {label: '有効取得件数', width: 'auto'},
    {label: '減額前', width: '4rem'},
    {label: '従量割引', width: '4rem'},
    {label: '実質割引率', width: '4rem'},
    {label: '減額後', width: '4rem'},
    {label: '課金区分', width: '4rem'},
    //{label: '長期', width: '2rem'},
    {label: '-', width: '2rem'},  // 長期割はしばらく適用せず、「長期」は一旦「-」を表示
  ]

  const drm_pf_api_details_th = [
    {label: 'API-ID', width: '5rem'},
    {label: '総取得件数', width: '6rem'},
    {label: '一時無償件数', width: '6rem'},
    {label: '有効取得件数', width: '6rem'},
    {label: '単価', width: '5rem'},
    {label: '小計金額（税抜）', width: '10rem'},
  ]

  const drm_pf_api_usages_th = [
    {label: '利用開始', width: '10rem'},
    {label: '利用終了', width: '10rem'},
    {label: 'IPアドレス', width: '8rem'},
    {label: 'API-ID', width: '5rem'},
    {label: '処理結果', width: '5rem'},
    {label: '処理区分', width: '5rem'},
    {label: '版情報', width: '5rem'},
    {label: '取得データ件数', width: '8rem'},
    {label: '単価', width: '5rem'},
    {label: '請求対象', width: '5rem'},
    {label: '一時無償', width: '5rem'},
    {label: '小計', width: '8rem'},
  ]

  const pageSizeOptions = [
    {
      value: '25',
      label: '25件',
    },
    {
      value: '50',
      label: '50件',
    },
    {
      value: '100',
      label: '100件',
    },
    {
      value: '200',
      label: '200件',
    },
  ]

  return {
    drm_pf_api_summary_th,
    drm_pf_api_summary_th_2nd,
    drm_pf_api_details_th,
    drm_pf_api_usages_th,
    pageSizeOptions
  }
}